const lowerBound = 2
const upperBound = 8

/** * @param {number} number */
const isHalf = (number) => {
  const half = parseInt((number % 1 * 10).toFixed())

  return half > lowerBound && half < upperBound
}

/** * @param {number} number */
const isAboveHalf = (number) => {
  const half = parseInt((number % 1 * 10).toFixed())

  return half >= upperBound
}

/** * @param {number} number */
export const starRating = (rating) => {
  const fixedValue = parseFloat((rating*1).toFixed(1))

  const displayValue = isAboveHalf(fixedValue)
    ? Math.ceil(fixedValue)
    : Math.trunc(fixedValue)

  return isHalf(fixedValue)
    ? `${displayValue}h`
    : `${displayValue}`
}

export default {
  starRating,
}